import React, { useState } from 'react';
import { Dropdown, Menu, Row, Space } from 'antd';
import Button from '@mui/material/Button';
import { DownOutlined, CheckOutlined } from '@ant-design/icons';
import {DoneRounded, ArrowDropDownRounded} from "@mui/icons-material";
import EditableItem from "./EditableItem";

const HoverMenu = ({ extraItems, onToggleExtraItems, initialSelectedItems }) => {
  const [menuVisible, setMenuVisible] = useState(false);
  const [selectedItems, setSelectedItems] = useState(initialSelectedItems || []);

  const handleMenuClick = (e) => {
    const itemId = e.key;
    setSelectedItems(current =>
      current.includes(itemId) ? current.filter(id => id !== itemId) : [...current, itemId]
    );
  };

  const handleVisibleChange = flag => {
    setMenuVisible(flag);
  };

  const handleSubmit = () => {
    onToggleExtraItems(selectedItems); // Pass all selected items at once
    setMenuVisible(false); // Optionally close the menu after submission
  };

  const menu = (
    <Menu multiple onClick={handleMenuClick}>
      {Array.isArray(extraItems) && extraItems.length > 0 && extraItems.map(item => (
        <Menu.Item key={item.id} icon={selectedItems.includes(item.id) ? <CheckOutlined /> : null}>
          {item.label}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Space size={'large'}>
      <Dropdown
        overlay={menu}
        trigger={['click']}
        onVisibleChange={handleVisibleChange}
        visible={menuVisible}
      >
        <Button endIcon={<ArrowDropDownRounded fontSize={'large'}/>} type={'primary'} className="ant-dropdown-link" onClick={e => e.preventDefault()}>
          More Options
        </Button>
      </Dropdown>
      <Button startIcon={<DoneRounded/>} type="primary" onClick={handleSubmit} variant={!selectedItems.length ? '':'contained'}>
        Submit
      </Button>
    </Space>
  );
};
const ItemController = ({ items, itemColors, onRemove, extraItems, onToggleExtraItems, initialSelectedItems }) => {
  let leftItems = items.map(item => (
    <EditableItem
      key={item.id}
      item={item}
      color={itemColors?.[item.id] ?? '#1890ff'}
      onRemove={onRemove}
    />
  ));

  return (
    <Row justify={'space-between'}>
      <Space>{leftItems}</Space>
      <Space>
        <HoverMenu extraItems={extraItems} onToggleExtraItems={onToggleExtraItems} initialSelectedItems={initialSelectedItems} />
      </Space>
    </Row>
  );
};

export default ItemController;
